<div
  (cdkDropListDropped)="onDrop($event)"
  [cdkDropListData]="statusFormArray().controls"
  cdkDropList
  class="flex flex-col gap-4"
>

  <!-- Display existing statuses -->
  @for (formGroup of statusFormArray().controls; track formGroup.value.id) {
    <div
      [cdkDragDisabled]="formGroup.enabled"
      cdkDrag
      class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-primary-50"
    >
      <div cdkDragHandle class="cursor-grab text-primary-200 hover:text-primary-500">
        <i class="pi pi-bars"></i>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameFr" [label]="'local.french' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameNl" [label]="'local.dutch' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameEn" [label]="'local.english' | translate"/>
      </div>
      <div>
        <elcia-color-picker [control]="formGroup.controls.color"/>
      </div>
      <div>
        <elcia-check-box [control]="formGroup.controls.isDefault" [label]="'todo.is-default' | translate"/>
      </div>
      <div>
        <elcia-check-box [control]="formGroup.controls.mustArchive" [label]="'todo.must-archive' | translate"/>
      </div>
      <div>
        <elcia-button
          (click)="toggleFormGroupEnableByStatusId(formGroup.value.id)"
          [icon]="formGroup.enabled ? 'save' : 'edit'"
          [severity]="formGroup.enabled ? 'primary' : 'secondary'"/>
      </div>
      <div>
        <elcia-button
          (click)="deleteStatus(formGroup.controls.id.value!)"
          icon="delete"
          severity="danger"
          variant="text"/>
      </div>
      <div *cdkDragPlaceholder class="status-drag-placeholder"></div>
    </div>
  }

  <!-- Status creation -->
  <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-dashed border-primary-100">
    <div class="flex-1">
      <elcia-text-input [control]="newStatusForm.controls.nameFr" [label]="'local.french' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="newStatusForm.controls.nameNl" [label]="'local.dutch' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="newStatusForm.controls.nameEn" [label]="'local.english' | translate"/>
    </div>
    <div>
      <elcia-color-picker [control]="newStatusForm.controls.color"/>
    </div>
    <div>
      <elcia-check-box [control]="newStatusForm.controls.isDefault" [label]="'todo.is-default' | translate"/>
    </div>
    <div>
      <elcia-check-box [control]="newStatusForm.controls.mustArchive" [label]="'todo.must-archive' | translate"/>
    </div>
    <div>
      <elcia-button
        (onClick)="saveForm()"
        [disabled]="newStatusForm.invalid"
        [icon]="'plus'"/>
    </div>
    <div class="w-[36px]"></div>
  </div>

</div>
